<template>
<div id="price_list" >
    <div class= "area-tab">
        <nav>
            <a @click="tab_click('SEAT')" :class="menu_tab_class_list['seat']">좌석</a>
            <a @click="tab_click('LOCKER')" :class="menu_tab_class_list['locker']">사물함</a>
            <a @click="tab_click('GROOM')" :class="menu_tab_class_list['groom']">그룹룸</a>
            <a :class="menu_tab_class_list['mileage']" @click="tab_click('MILEAGE')">마일리지</a>
            <!-- 251127 기타 탭 추가 -->
            <a :class="menu_tab_class_list['etc']" @click="tab_click('etc')">기타</a>
        </nav>
    </div>
    <div class="price-table">
        <div class="obj obj1 list_obj" :style="menu_tab_style_list['seat']">
            <div class="tab_contents">
                <div class="table-wrapper">
                    <table class="table02 table-head">
                        <colgroup>
                            <col width="15%;" />
                            <col width="23%;" />
                            <col width="15%;" />
                            <col width="15%;" />
                            <col width="16%;" />
                        </colgroup>
                        <tr>
                            <th>타입</th>
                            <th>상품명</th>
                            <th>이용 시간</th>
                            <th>사용 기간</th>
                            <th>금액</th>
                        </tr>
                        <!-- <tr>
                            <th>현금</th>
                            <th>카드</th>
                        </tr> -->
                    </table>
                    <div class="scroll-area hidden-scroll">
                        <table class="table02 table-body">
                        <colgroup>
                            <col width="15%;" />
                            <col width="23%;" />
                            <col width="15%;" />
                            <col width="15%;" />
                            <col width="16%;" />
                        </colgroup>
                        <tbody v-for="(item,index) in seat" :key="index+'seat'">
                            <template v-for="(info, idx) in item.info">
                            <tr :key="'tr01'+idx">
                                <td >
                                    <template v-if="idx === 0">{{word_break(item.seat_type_name)}}</template>
                                    <template v-else></template>
                                </td>
                                <td>
                                    <template v-if="idx === 0">{{word_break(item.goods_group_name)}}</template>
                                    <template v-else></template>
                                </td>
                                <td>{{word_break(info.hours)}}</td>
                                <td>{{info.day_count}}
                                    <span v-if="info.day_count !== null && info.day_continue == '0'">일</span>
                                    <span v-else-if="info.day_count !== null && info.day_continue == '1'">일(연장)</span>
                                </td>
                                
                                <!-- <td class="price">{{info.cash_amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</td> -->
                                <td class="price">{{info.card_amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</td>
                            </tr>
                            </template>
                        </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <a v-if="this.purchase_goods_check" href="#" @click="seat_purchase" class="add-service"><div class="btn_03 add-btn">상품 별도구매</div></a>
        </div>
        <div class="obj obj2 list_obj" :style="menu_tab_style_list['locker']">
            <div class="tab_contents">
                <div class="table-wrapper">
                    <table class="table02 table-head">
                        <colgroup>
                            <col width="33%;" />
                            <col width="33%;" />
                            <col width="33%;" />
                        </colgroup>
                        <tr>
                            <th>타입</th>
                            <th>이용 시간</th>
                            <th>금액</th>
                        </tr>
			        </table>
			        <div class="scroll-area hidden-scroll">
				        <table class="table02 table-body">
					    <colgroup>
                            <col width="33%;" />
                            <col width="33%;" />
                            <col width="33%;" />
                        </colgroup>
                        <tbody v-for="(item,index) in locker.info" :key="index+'locker'">
                            <tr>
                            <td>
                                <template v-if="index === 0">{{item.locker_name}}</template>
                                <template v-else-if="locker.info[index-1].locker_name != locker.info[index].locker_name">{{item.locker_name}}</template>
                                <template v-else></template>
                            </td>
                            <td>{{item.use_day_count}}일</td>
                            <td class="price">{{item.card_amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</td>
                            </tr>
                        </tbody>
                        </table>
			        </div>
                </div>
            </div>
        </div>
        <div class="obj obj3 list_obj" :style="menu_tab_style_list['groom']">
            <div class="tab_contents">
                <div class="list_05_btn" @click="map_group_sel_pop = true">
                    <span>{{sel_group_name}}</span><font-awesome-icon :icon="['fas', 'sort-down']" />                
                </div>
                <div class="list_05_select_pop_wrap" v-if="map_group_sel_pop">
                    <div class="list_05_select_pop">
                        <ul>
                            <li v-for="(item,index) in groom_list" :key="index" :id="item.groom_id" @click="select_groom(item)" :class="item.class">{{item.tab_name}} - {{item.groom_name}}</li>
                        </ul>
                    </div>
                </div>
                
                <p class="clear"></p>
                <img class="tit-img-point" src="../../assets/image/groom-pop-icon1.png"><p class="tit01" style="display:inline-block;">그룹룸 정보</p>
                <div class="table-wrapper">
                <table class="table01">
                    <colgroup>
                    <col width="20%;" />
                    <col width="50%;" />
                    <col width="20%;" />
                    <col width="10%;" />
                    </colgroup>
                    <tr>
                        <th>이름</th>
                        <td>{{groom_name}} <span v-if="type_name.length > 0">({{type_name}})</span></td>
                        <th>좌석수</th>
                        <td class="groom_seat">{{groom_seat_count}}</td>
                    </tr>
                    <tr>
                        <th>정보</th>
                        <td colspan="3" >
                            <p v-html="groom_info" class='p_scroll hidden'>
                            </p>
                        </td>
                    </tr>
                </table>
                </div>
                <br>
                <div class="table-wrapper">
                    <table class="table02 table-head">
                        <colgroup>
                            <col width="25%;" />
                            <col width="25%;" />
                            <col width="15%;" />
                            <col width="15%;" />
                            <col width="20%;" />
                        </colgroup>
                        <tr>
                            <th>타입</th>
                            <th>상품명</th>
                            <th>이용 시간</th>
                            <th>사용 기간</th>
                            <th>금액</th>
                        </tr>
                    </table>
                    <div class="scroll-area hidden-scroll">
                        <table class="table02 table-body">
                            <colgroup>
                                <col width="25%;" />
                                <col width="25%;" />
                                <col width="15%;" />
                                <col width="15%;" />
                                <col width="20%;" />
                            </colgroup>
                            <tbody v-for="(item,index) in groom" :key="index+'groom'">
                                <template v-for="(info, idx) in item.info">
                                    <tr :key="idx+'groom_info'">
                                        <td>
                                            <template v-if="idx === 0">{{word_break(item.groom_name)}}</template>
                                            <template v-else></template>
                                        </td>
                                        <td>
                                            <template v-if="idx === 0">{{word_break(item.goods_group_name)}}</template>
                                            <template v-else></template>
                                        </td>
                                        <td>{{word_break(info.use_time)}}<span v-if="info.use_time !== null"></span></td>
                                        <td>{{info.end_day_count}}<span v-if="info.end_day_count !== null">일</span></td>
                                        <td class="price">{{info.card_amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</td>
                                    </tr>
                                </template>
                            </tbody>
                        </table>
                    </div>
                </div>
                
            </div>
            <!-- 251113 그룹룸 시간충전권 별도구매 추가 -->
            <a v-if="groom_goods_pay_yn" href="#" @click="groom_time_purchase" class="add-service"><div class="btn_03 add-btn">상품 별도구매(시간권)</div></a>
        </div>
        <!-- 251127 기타상품 별도구매 추가 -->
         <template v-if="get_m_etc_goods_pay_yn">
            <!-- 매장별 모바일 기타상품 판매여부 활성화 옵션 -->
            <div class="obj obj4 list_obj" :style="menu_tab_style_list['etc']">
                <div class="tab_contents">
                    <div class="table-wrapper">
                        <table class="table02 table-head">
                            <colgroup>
                                <col width="33%;" />
                                <col width="33%;" />
                            </colgroup>
                            <tr>
                                <th>타입</th>
                                <th>금액</th>
                            </tr>
                        </table>
                        <div class="scroll-area hidden-scroll">
                            <table class="table02 table-body">
                            <colgroup>
                                <col width="33%;" />
                                <col width="33%;" />
                            </colgroup>
                            <tbody v-for="(item,index) in etc.info" :key="index+'etc'">
                                <tr>
                                <td>
                                    <template v-if="index === 0">{{item.goods_name}}</template>
                                    <template v-else-if="etc.info[index-1].goods_name != etc.info[index].goods_name">{{item.goods_name}}</template>
                                    <template v-else></template>
                                </td>
                                <td class="price">{{item.card_amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</td>
                                </tr>
                            </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <!-- 기능 활성화 여부, 별도구매 가능 사용자 여부 체크 옵션 -->
                <a v-if="etc_goods_pay_yn && etc_use_user" href="#" @click="etc_goods_purchase" class="add-service"><div class="btn_03 add-btn">상품 별도구매</div></a>
            </div>
        </template>

        <template v-if="mileage_charge_use_yn == 1">
            
            <div class="obj obj1 list_obj" :style="menu_tab_style_list['mileage']">
                <div class="tab_contents">
	                <div class="table-wrapper">
                        <table class="table02 table-head">
                            <colgroup>
                                <col width="50%;" />
                                <col width="50%;" />
                            </colgroup>
                            <tr>
                                <th rowspan="2">충전 금액</th>
                                <th colspan="2">금액</th>
                            </tr>
                        </table>
			            <div class="scroll-area hidden-scroll">
				            <table class="table02 table-body">
                                <colgroup>
                                    <col width="50%;" />
                                    <col width="50%;" />
                                </colgroup>
                                <tbody v-for="(item,index) in mileage.info" :key="index+'locker'">
                                    <tr>
                                        <td>{{item.charge_amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}} M</td>
                                        <td class="price">{{item.card_amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
	                </div>
                </div>
            </div>
        </template>
        
        
    </div>
</div>
</template>

<script>
var self = this;
import * as config from '../../javascript/config';
export default {
    name: 'price_list',
    data() {
        return {
            tab_step: 'tab1',
            // 가격표 데이터
            seat: [],
            locker: [],
            groom: [],
            mileage: [],
            etc: [], //251127 etc 추가
            // groom 관련
            groom_all_list: [],
            groom_list: [],
            wid_scroll_left: false,
            wid_scroll_right: false,
            add_step: 0,
            // groom detail
            groom_name: '',
            groom_info: '',
            groom_seat_count: '',
            menu_tab_style_list: {'seat':'display:block;', 'locker':'display:none;', 'groom':'display:none;','mileage':'display:none;', 'mileage':'display:none;'}, //251127 etc 추가
            menu_tab_class_list: {'seat':'ov', 'locker':'', 'groom':'','mileage':'', 'etc':''}, //251127 etc 추가
            type_name:'',
            purchase_goods_check: false,
            //마일리지 충전매장 체크관련
            mileage_charge_use_yn:'',
            notice_box:'notice_box',
            tab_data: Object, // 탭(층) 정보
            map_group_sel_pop : false,
            sel_group_name : '',
            store_pay_yn: this.$store.getters['getStore_pay_info'],

            groom_goods_pay_yn: false, //그룹룸 시간충전권 구매 플래그
            etc_goods_pay_yn: false, //기타상품 구매 플래그
            etc_use_user: false //기타상품 구매 가능 사용자체크
        }

    },
    methods: {
        tab_click(tab_id) {
            if(tab_id == 'GROOM'){				
				if(typeof this.groom_list[0] === 'undefined'){
	        		const alert_param = {
	                    code: this.$store.getters['get_popup_code'].POPUP_ALERT,
	                    message: `해당매장은 그룹룸이 없는 매장 입니다.`,
	                    router: '',
	                    image_type: 'warning'
	                };
	                this.$store.commit('set_popup_type', alert_param);
	                return; 
	        	}else{
                	this.select_groom(this.groom_list[0]);
                }
            } 
            this.setting_menu(tab_id);
            this.$store.commit('set_price_page_tab_code', {
                'tab_code':tab_id
            });
        },
        //seat controll
        seat_purchase() {
            if (!this.$store.state.login_chk) {
                this.$store.commit('set_Last_URL', '/price_list');
                // this.$router.push('/login');
            } else {
                this.$router.push('/payment-seat_product');
            }
        },
        // 251113 그룹룸 시간충전권 별도구매 추가 
        groom_time_purchase() {
            if (!this.$store.state.login_chk) {
                this.$store.commit('set_Last_URL', '/price_list');
            } else {
                this.$router.push('/payment-group_room_product');
            }
        },
        // 251127 기타상품 별도구매 추가 
        etc_goods_purchase() {
            if (!this.$store.state.login_chk) {
                this.$store.commit('set_Last_URL', '/price_list');
            } else {
                this.$router.push('/payment-etc');
            }
        },
        start_seat() {
            this.$store.commit('change_main_tab_chk', {
                value: 0
            });
            // this.$store.state.main_tab_chk = 0; // main tab defalt value 셋팅 0 = 좌석 , 1 = 사물함 , 2 = 그룹룸
            this.$router.push('/');
        },
        //locker controll
        start_locker() {
            this.$store.commit('change_main_tab_chk', {
                value: 1
            });
            // this.$store.state.main_tab_chk = 1; // main tab defalt value 셋팅
            if (!this.$store.state.login_chk) {
                // this.$router.push('/login');
            } else {
                this.$router.push('/');
            }

        },
        //group room controll
        start_groom() {
            this.$store.commit('change_main_tab_chk', {
                value: 2
            });
            // this.$store.state.main_tab_chk = 2; // main tab defalt value 셋팅
            this.$router.push('/');
        },
        purchase_groom() {
            if (!this.$store.state.login_chk) {
                // this.$router.push('/login');
                this.$store.commit('set_Last_URL','/price_list');
            } else {
                this.$router.push('/payment-group_room_product');
            }
        },
        mileage_purchase() {
            if (!this.$store.state.login_chk) {
                this.$store.commit('set_Last_URL','/price_list');
                // this.$router.push('/login');
            } else {
                this.$router.push('/payment_mileage');
            }
        },
        step(val) {
            this.add_step += val;
            for (let i = 0; i < this.groom_all_list.length; i++) {
                if (this.add_step == i) {
                    this.groom_list = this.groom_all_list[i].grooms;
                }
            }

            if (this.groom_all_list.length == this.add_step + 1) {
                this.wid_scroll_right = false;
            } else {
                this.wid_scroll_right = true;
            }
            if (this.add_step != 0) {
                this.wid_scroll_left = true;
            } else {
                this.wid_scroll_left = false;

            }
        },
        select_groom(g_data) {

            this.groom_name = g_data.groom_name;
            this.groom_info = g_data.groom_info;
            this.groom_seat_count = g_data.seat_count;
            this.type_name = g_data.type_name;

            // 그룹룸 가격정보
            const groom_price_list = config.REQ_GROOM_PRICE_GET_LIST;
            const price_data = { 'groom_name' : this.groom_name }

            this.$store.dispatch(groom_price_list.action_name, {
                type: groom_price_list,
                data: price_data
            }).then(response => {
              this.$store.commit('set_groom_price_list', {
                  vo: response.data
              });
            }).catch(function (error) {
                console.log('error=============>', error);
            });

            for (let i = 0; i < this.groom_list.length; i++) {
                if (g_data.groom_id == this.groom_list[i].groom_id) {
                    // document.getElementById(this.groom_list[i].groom_id).setAttribute("class","over");
                    this.groom_list[i].class = 'on';
                } else {
                    this.groom_list[i].class = 'over';
                    // document.getElementById(this.groom_list[i].groom_id).setAttribute("class","");
                }
            }
            this.sel_group_name = g_data.tab_name + " - " + g_data.groom_name;
            this.map_group_sel_pop = false;
        },
        setting_menu(tab_id){
            if(tab_id == "GROOM"){
                this.menu_tab_style_list['seat'] = 'display:none;'
                this.menu_tab_class_list['seat'] = ''
                this.menu_tab_style_list['locker'] = 'display:none;'
                this.menu_tab_class_list['locker'] = ''
                this.menu_tab_style_list['groom'] = 'display:block;'
                this.menu_tab_class_list['groom'] = 'ov'
                this.menu_tab_style_list['mileage'] = 'display:none;'
                this.menu_tab_class_list['mileage'] = ''
                this.menu_tab_style_list['etc'] = 'display:none;'
                this.menu_tab_class_list['etc'] = ''
                this.tab_step = 'tab3';

            }else if(tab_id == "SEAT" || tab_id == ""){
                this.menu_tab_style_list['seat'] = 'display:block;'
                this.menu_tab_class_list['seat'] = 'ov'
                this.menu_tab_style_list['groom'] = 'display:none;'
                this.menu_tab_class_list['groom'] = ''
                this.menu_tab_style_list['locker'] = 'display:none;'
                this.menu_tab_class_list['locker'] = ''
                this.menu_tab_style_list['mileage'] = 'display:none;'
                this.menu_tab_class_list['mileage'] = ''
                this.menu_tab_style_list['etc'] = 'display:none;'
                this.menu_tab_class_list['etc'] = ''
                this.tab_step = 'tab1';
            }else if(tab_id == "LOCKER"){
                this.menu_tab_style_list['seat'] = 'display:none;'
                this.menu_tab_class_list['seat'] = ''
                this.menu_tab_style_list['groom'] = 'display:none;'
                this.menu_tab_class_list['groom'] = ''
                this.menu_tab_style_list['locker'] = 'display:block;'
                this.menu_tab_class_list['locker'] = 'ov'
                this.menu_tab_style_list['mileage'] = 'display:none;'
                this.menu_tab_class_list['mileage'] = ''
                this.menu_tab_style_list['etc'] = 'display:none;'
                this.menu_tab_class_list['etc'] = ''
                this.tab_step = 'tab2';
            }else if(tab_id == "MILEAGE"){
                this.menu_tab_style_list['seat'] = 'display:none;'
                this.menu_tab_class_list['seat'] = ''
                this.menu_tab_style_list['groom'] = 'display:none;'
                this.menu_tab_class_list['groom'] = ''
                this.menu_tab_style_list['locker'] = 'display:none;'
                this.menu_tab_class_list['locker'] = ''
                this.menu_tab_style_list['mileage'] = 'display:block;'
                this.menu_tab_class_list['mileage'] = 'ov'
                this.menu_tab_style_list['etc'] = 'display:none;'
                this.menu_tab_class_list['etc'] = ''
                this.tab_step = 'tab4';
            }else if(tab_id == "etc"){
                // 251127 기타 추가
                this.menu_tab_style_list['seat'] = 'display:none;'
                this.menu_tab_class_list['seat'] = ''
                this.menu_tab_style_list['groom'] = 'display:none;'
                this.menu_tab_class_list['groom'] = ''
                this.menu_tab_style_list['locker'] = 'display:none;'
                this.menu_tab_class_list['locker'] = ''
                this.menu_tab_style_list['mileage'] = 'display:none;'
                this.menu_tab_class_list['mileage'] = ''
                this.menu_tab_style_list['etc'] = 'display:block;'
                this.menu_tab_class_list['etc'] = 'ov'
                this.tab_step = 'tab5';
            }
        },
        word_break(val){
            if(val){
                if(val.indexOf('(') != -1){
                    return val.split('(')[0] + " (" + val.split('(')[1];
                }else{
                    return val;
                }
            }
        },
        chkFeatureFlag(el, configKey, storeId){
            if(el.config_key != configKey) return false;
            if(el.config_yn != 'Y') return false; //매장 전체 비활성화
            if(el.config_yn == 'Y') {
                if(el.partial_yn != 'Y') return true; // 매장 전체 활성화(부분적용은 x)
                //부분적용 시 해당 매장만 활성화
                let isStoreYn = el.partial_store_ids ? el.partial_store_ids.split(',') : [];
                return isStoreYn.includes(storeId.toString());
            }
        }
    },
    computed:{
        get_tab_step_info(){
            return this.tab_step;
        },
        get_price_page_tab_code(){
            return this.$store.getters['get_price_page_tab_code'];
        },
        // 251127 모바일 기타상품 결제 활성화 여부 체크
        get_m_etc_goods_pay_yn(){
            return this.$store.getters['get_store_option'].m_etc_goods_pay_yn && this.$store.getters['get_store_option'].m_etc_goods_pay_yn == 1 ? true : false;
        }
    },
    mounted() {
        var yndata = this.$store.getters['getUseyn'];
        this.mileage_charge_use_yn = yndata.mileage_charge_use_yn;

        if(this.mileage_charge_use_yn == 1){
            this.notice_box = 'notice_box four';
        }

        if (this.$store.state.from_groom) {
            this.tab_click('GROOM');
            this.$store.commit('change_from_groom', {
                value: false
            });
            // this.$store.state.from_groom = false;
        }

        var tab_id = this.$store.getters['get_price_page_tab_code'];
        this.setting_menu(tab_id);

        // 가격표 data 요청후 리퀘스트

        // 좌석 - 가격정보
        const seat_price_list = config.REQ_SEAT_PRICE_GET_LIST;
        // 사물함 가격정보   =>  Unknown column 'B.groom_id' error 있음
        const locker_price_list = config.REQ_LOCKER_PRICE_GET_LIST;
        // 좌석 상품 정보
        const goods_group_list = config.REQ_SEAT_GOODS_USE_YN_GET;
        // 마일리지 상품 정보
        const mileage_price_list = config.REQ_MILEAGE_PRICE_GET_LIST;
        // 251127 기타 상품 정보 추가 
        const etc_price_list = config.REQ_ETC_PRICE_GET_LIST;

        const price_data = {}
        Promise.all(
            [
                this.$store.dispatch(seat_price_list.action_name, {
                    type: seat_price_list,
                    data: price_data
                }),
                this.$store.dispatch(locker_price_list.action_name, {
                    type: locker_price_list,
                    data: price_data
                }),
                this.$store.dispatch(goods_group_list.action_name, {
                    type: goods_group_list,
                    data: price_data
                }),
                this.$store.dispatch(mileage_price_list.action_name, {
                    type: mileage_price_list,
                    data: price_data
                }),
                // 251127 기타 상품 정보 추가
                this.$store.dispatch(etc_price_list.action_name, {
                    type: etc_price_list,
                    data: price_data
                }),
            ]
        ).then(responseList => {
            //console.log(responseList)
            // 응답 - 요청 순서별 응답 array
            this.$store.commit('set_seat_price_list', {
                vo: responseList[0].data
            });
            this.$store.commit('set_locker_price_list', {
                vo: responseList[1].data
            });
            this.$store.commit('set_mileage_price_list', {
                vo: responseList[3].data
            });
            // 251127 기타 상품 정보 추가
            this.$store.commit('set_etc_price_list', {
                vo: responseList[4].data
            });

            for(var idx=0; idx<responseList[2].data.length; idx++){
                if(responseList[2].data[idx].purchase_goods_yn == 1){
                    this.purchase_goods_check = true;
                }
            }

        }).catch(function (error) {
            console.log('error=============>', error);
        });

        this.seat = this.$store.getters['get_seat_price_list'];
        this.locker = this.$store.getters['get_locker_price_list'];
        this.groom = this.$store.getters['get_groom_price_list'];
        this.mileage = this.$store.getters['get_mileage_price_list'];
        this.etc = this.$store.getters['get_etc_price_list']; //251127 추가

        // 그룹룸 data
        //그룹룸 리스트 갱신
        const type_groom_list = config.REQ_GROOM_GROUPROOM_GET_LIST;
        const data = {};
        this.$store.dispatch(type_groom_list.action_name, {
            type: type_groom_list,
            data: data
        }).then(response => {
            this.groom_all_list = response.data;

                        
            // 탭(층) 관련로직
            this.tab_data = this.$store.getters['get_map_group_list'];
            if (this.tab_data.length != 0) {
                var floor_index = 0;
                var floor_group = 1;
                for (let i = 0; i < this.tab_data.length; i++) {
                    if (this.tab_data[i].tab_name.length > 4) {
                        var slice_str = this.tab_data[i].tab_name.slice(0, 4);
                        this.tab_data[i].tab_name_main = slice_str + "..";
                    } else {
                        this.tab_data[i].tab_name_main = this.tab_data[i].tab_name;
                    }
                }
                this.tab_index = 0;
            }
            
            this.groom_all_list_arr = new Array();         
            var z = 0;

            for(let x = 0; x < this.tab_data.length; x++){

                for(let i = 0; i < this.groom_all_list.length; i++){
                    if(this.groom_all_list[i].map_group_id == this.tab_data[x].map_group_id){
                        for(let j = 0; j < this.groom_all_list[i].grooms.length; j++ ){
                            this.groom_all_list_arr[z] = this.groom_all_list[i].grooms[j];
                            this.groom_all_list_arr[z].tab_name = this.tab_data[x].tab_name;
                            z++;
                        }
                    }
                }
            }             

            this.groom_list = this.groom_all_list_arr;

            if (this.groom_all_list.length > 1) {
                this.wid_scroll_right = true;
            }
            this.groom_name = this.groom_list[0].groom_name;
            this.groom_info = this.groom_list[0].groom_info;
            this.groom_seat_count = this.groom_list[0].seat_count;
            this.groom_list[0].class = 'over';
            this.sel_group_name = this.groom_list[0].tab_name + " - " + this.groom_list[0].groom_name;

            // this.tab_click('GROOM');
        }).catch(function (error) {
            console.log('error=============>', error);
        });

        //251127 별도상품구매 기능 활성화 플래그 가져오기
        const featureMap = {};
        const feture_flag_get = config.REQ_FEATURE_FLAG_YN;
        const key_data = { key: ['M_GROOM_GOODS_PAY', 'M_ETC_GOODS_PAY'] };
        this.$store.dispatch(feture_flag_get.action_name, {
            type: feture_flag_get,
            data: key_data
        }).then(response => {
            //console.log(response)
            if(response && response.data){
                response.data.forEach(el => {
                    featureMap[el.config_key] = el; //키 별로 데이터 담아두기
                });
                // 그룹룸 별도 구매 여부 판단
                this.groom_goods_pay_yn = this.chkFeatureFlag(featureMap['M_GROOM_GOODS_PAY'], 'M_GROOM_GOODS_PAY', this.$store.getters['getStoreId']);
                // 기타상품 별도 구매 여부 판단
                this.etc_goods_pay_yn = this.chkFeatureFlag(featureMap['M_ETC_GOODS_PAY'], 'M_ETC_GOODS_PAY', this.$store.getters['getStoreId']);
            }
            
        }).catch(function (error) {
            console.log('error=============>', error);
        });

        // 좌석상품 보유시에만 기타상품 구매 옵션 가져오기
        const etc_use_check = config.REQ_ETC_USE_CHECK;
        this.$store.dispatch(etc_use_check.action_name, {
            type: etc_use_check, 
            data: {}
        }).then(response => { 
            if(response && response.result){
                this.etc_use_user = response.result;
            }
        }).catch(function (error) {
            console.log('error=============>', error);
        });

        this.$store.commit('set_main_page_top_menu_code', {
            'menu_code': "PRICE"
        });
    },created(){
    },watch:{
        get_tab_step_info(kind) {            /* 
            let menu_list = document.querySelectorAll('.area-tab nav a');
            menu_list.forEach(e => {
                if(e.classList.length > 0){
                    e.classList.remove('active');
                }
            });
            let idx = kind.replace("tab","")*1 - 1;
            menu_list[idx].classList.add('active'); */
        },
        get_price_page_tab_code(){
            var tab_id = this.$store.getters['get_price_page_tab_code'];
            this.setting_menu(tab_id);
        },
    }
}
</script>
<style>
    .obj1.list_obj{
        position: relative;
    }
    .obj3.list_obj{
        position: relative;
    }
    .obj4.list_obj{
        position: relative;
    }
    .add-service{
        position: absolute;
        bottom:-40px;
        left:50%;
        padding:0 16px;
        display:flex;
        gap:8px;
        align-items:center; 
        width:90%;
        transform: translateX(-50%);
    }
    .add-service .add-btn {
        width:100%;
        height: 40px;
        background:#4C91EC;
        border-radius:4px;
        color:#fff;
        font-size:14px; 
        display:flex;
        justify-content:center;
        align-items:center;
        box-sizing:border-box;
        font-weight:500; 
    }
</style>


// WEBPACK FOOTER //
// src/components/page/price_list.vue